import { useState, useEffect, useContext } from "react";
import { BlocksValue } from "../../../../contexts/blocks";
import PropInput from "../propinput";
import Media from "./media";
import Dyanmic from "./dynamic";
import SelectChild from "./selectChild";
import styles from "./styles.module.css";
import Dynamic from "./dynamic";
import Transition from "./transition";

export default function Condition({
  condition,
  schema,
  block,
  index,
  sources,
  onChange,
  children,
  onDelete,
}) {
  const [_schema, setSchema] = useState(null);
  const blocks = useContext(BlocksValue);

  useEffect(() => {
    if (!condition.element) {
      setSchema(schema);
    } else {
      const child = children.find((x) => x.id === condition.element);
      if (!child) return setSchema(null);
      const schema = blocks.find((x) => x.name === child.component);
      setSchema(schema);
    }
  }, [condition.element]);

  const handleStateChange = (v) => {
    const _condition = { ...condition };
    _condition.state = v;
    onChange(_condition);
  };

  const handleAddProp = (v) => {
    const _prop = block.props[v];
    const _condition = { ...condition };
    _condition.props[v] = _prop;
    onChange(_condition);
  };
  const handleDeleteProp = (key) => {
    const _condition = { ...condition };
    delete _condition.props[key];
    onChange(_condition);
  };

  if (!_schema) {
    return <div />;
  }

  return (
    <div className={styles.condition}>
      <div className={styles.propTitle}>State</div>
      <select
        onChange={(e) => handleStateChange(e.target.value)}
        value={condition.state}
        className={"dropdown"}
      >
        <option disabled value="">
          select...
        </option>
        <optgroup label="Basic">
          {schema.cssStates &&
            schema.cssStates.map((c) => {
              return <option value={c}>{c}</option>;
            })}
        </optgroup>
        <option value={"media"}>Screen Size</option>
        <option value={"dynamic"}>Dynamic</option>
      </select>
      {condition.state === "media" && (
        <Media sources={sources} condition={condition} onChange={onChange} />
      )}
      {condition.state === "dynamic" && (
        <Dynamic condition={condition} onChange={onChange} sources={sources} />
      )}
      {children.length > 0 && (
        <SelectChild
          children={children}
          condition={condition}
          onChange={onChange}
        />
      )}
      {Object.keys(condition.props).length > 0 && (
        <Transition condition={condition} onChange={onChange} />
      )}
      <div style={{ marginTop: 12 }} className={styles.propTitle}>
        Props
      </div>
      {Object.keys(condition.props).map((key) => {
        const prop = _schema.props.find((x) => x.name === key);
        if (!prop) {
          return null;
        }
        return (
          <PropInput
            onChange={onChange}
            sources={[]}
            index={index}
            key={prop.name}
            block={condition}
            prop={prop}
            onDelete={() => handleDeleteProp(key)}
          />
        );
      })}
      <select
        onChange={(e) => handleAddProp(e.target.value)}
        value={""}
        className={"dropdown"}
        style={{ marginTop: 12 }}
      >
        <option disabled value="">
          select prop...
        </option>
        {_schema.props
          .filter(
            (x) => !!x.editorParams.styleName || condition.state === "dynamic"
          )
          .map((p) => {
            return <option value={p.name}>{p.displayName}</option>;
          })}
      </select>
      <div onClick={onDelete} className={styles.deleteCondition}>
        Delete Condition
      </div>
    </div>
  );
}
